import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { IInventoryState } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { IGoodInventoryPageProps } from "../TransferInventory";
import { useClinicTamsFilterAPI } from "@/app/hooks/api_hooks/Inventory/useClinicTamsFilterAPI";

const TransferOrderReadOnly = () => {
  const { getRouteKey } = useRouter();
  const navigate = useNavigate();
  const { toNumber, transferInventoryItems } = useRouteInfo(getRouteKey("INVENTORY", "id")).routeState
    .state as IInventoryState;
  const { execute: fetchClinicList, clinicList } = useClinicTamsFilterAPI();
  const clinicsOrgItem = useSelectMenuReducer(clinicList, "display_name", "id");

  const formHook = useForm<IGoodInventoryPageProps>({
    mode: "onChange",
    defaultValues: {},
  });

  useEffect(() => {
    if (toNumber?.transfer_order_number) {
      localStorage.setItem("transfer_order_number", toNumber.transfer_order_number);
    }
  }, [toNumber]);

  const storedOrderNumber = localStorage.getItem("transfer_order_number");

  useEffect(() => {
    fetchClinicList("", transferInventoryItems?.warehouse);
  }, []);

  return (
    <div className="bg-white px-4 py-3 rounded-md">
      <h2 className="font-semibold text-base">Transfer Order</h2>
      <form>
        <div className="flex justify-start items-baseline mt-5">
          <div className="flex justify-start items-center gap-1 p-2.5 w-[150px] h-[38px]">
            <span className="font-normal text-black text-xs">Receiver Clinic</span>
            <span className="font-normal text-rose-600 text-xs">*</span>
          </div>
          <SearchableSelectMenu
            errorMessages={[{ type: "required", message: "Receiver Clinic is required" }]}
            onSelectItem={(item) => {
              if (item) {
                formHook.setValue("receiverClinic", { id: item?.id, name: item?.title });
                formHook.clearErrors("receiverClinic");
              }
            }}
            fieldError={formHook.formState.errors.receiverClinic}
            register={formHook.register("receiverClinic", { required: true })}
            selectItems={clinicsOrgItem?.filter((c) => c?.id !== transferInventoryItems?.senderClinic.id)}
            placeholder="Select Receiver Clinic"
            showTooltips={false}
            showTypedErrors={true}
            showDropdownIcon={true}
            className="text-gray-800"
            containerClassName="w-[300px]"
          />
        </div>
        <div className="flex justify-start items-baseline mt-3 pb-5 border-b-2">
          <div className="flex justify-start items-center gap-1 p-2.5 w-[150px] h-[38px]">
            <span className="font-normal text-black text-xs">Order ID</span>
          </div>
          <p>{toNumber?.transfer_order_number || storedOrderNumber}</p>
        </div>
        <h2 className="mt-5 font-semibold text-base">Order List</h2>
        <div className="shadow-md mt-9">
          <table className="border rounded-md divide-y divide-gray-200 w-full">
            <thead className="top-0 sticky bg-[rgb(244,249,254)]">
              <tr>
                <th className="px-3 py-3 font-medium text-black text-left text-sm">Product Name</th>
                <th className="px-3 py-3 font-medium text-black text-left text-sm whitespace-nowrap">Transfer Qty</th>
                <th className="px-3 py-3 font-medium text-black text-left text-sm whitespace-nowrap">Lot</th>
                <th className="px-3 py-3 font-medium text-black text-left text-sm whitespace-nowrap">Manufacturer</th>
                <th className="px-3 py-3 font-medium text-black text-left text-sm whitespace-nowrap">Expiry</th>
                <th className="px-3 py-3 font-medium text-black text-left text-sm whitespace-nowrap">MRP</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-orange-100">
              {transferInventoryItems?.selectedItems?.length > 0 ? (
                transferInventoryItems?.selectedItems?.map((item, i) => (
                  <tr key={i}>
                    <td className={"px-3 py-4 text-xs font-normal text-left"}>
                      <p className="w-[235px]">{item.product_name}</p>
                    </td>
                    <td className={"px-3 py-4 text-xs font-normal text-left"}>{item.transferQty}</td>
                    <td className={"px-3 py-4 text-xs font-normal text-left"}>{item.lot_number}</td>
                    <td className={"px-3 py-4 text-xs font-normal text-left"}>{item.manufacturer_name}</td>
                    <td className={"px-3 py-4 text-xs font-normal text-left"}> </td>
                    <td className={"px-3 py-4 text-xs font-normal text-left"}>{item.mrp}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7}>
                    <div className="flex justify-center bg-white rounded-md w-full h-full"></div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="right-5 bottom-5 fixed flex gap-x-3 p-3 rounded-md">
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              navigate(-1);
            }}
            type="button"
            className="bg-gray-500 bg-opacity-10 mt-5 px-4 py-2 rounded-md font-medium text-black text-sm cursor-pointer"
          >
            Back
          </button>
          <input
            type="submit"
            value={"Create TO"}
            className={`mt-5 px-4 py-2 rounded-md font-medium text-sm text-white bg-[#193A6A] cursor-pointer`}
          />
        </div>
      </form>
    </div>
  );
};

export default TransferOrderReadOnly;
